import {
    COMPARADOR_LOAD_VEHICLES_BEGIN,
    COMPARADOR_LOAD_VEHICLES_FAILURE,
    COMPARADOR_LOAD_VEHICLES_SUCCESS,
    
} from './constants'
import axios from 'axios'
import { MAESTRO } from '../Constants'
import { getBasePath, getThumbnail } from '../utils/utils'
import { getTechnicalSpecs } from '../technical-specs/TechnicalSpecsClass'
import { getInitialRelevantAttributes } from '../relevant-attributes/relevantAttributesClass'
import { getLineasFinancieras } from 'BFF/BFF_simulador/getLineasFinancieras'
import { formatNumber, getBestFinancingLine, getExceedFinanceLimitLegend } from 'Utilities'
import { DATAMASTER_ENDPOINT, FILES_ENDPOINT } from 'cfgCommon/endpoints'

const BFL_ERROR_MESSAGE = 'Error al cargar la línea financiera.'

export function loadVehicle(id, origin, index) {
    return (dispatch) => {
        if (!id || !origin || index === undefined) {
            return null
        }

        dispatch({ type: COMPARADOR_LOAD_VEHICLES_BEGIN, index })

        const doRequest = axios.all([
            axios.get(`${getBasePath(origin)}/${id}`),
            axios.get(`${FILES_ENDPOINT}/${origin === MAESTRO ? 'MAESTRO' : 'PRODUCTO'}/${id}`)
        ])

        let bestFinancingLineData = {message: [BFL_ERROR_MESSAGE]}
        doRequest.then(
            async (res) => {
                let responseVehicleData = res[0].data.data
                const responseFilesData = res[1].data.data

                await getLineasFinancieras(responseVehicleData).then(async resLineasFinancieras => {
                    if (origin === MAESTRO) {
                        bestFinancingLineData = {
                            message: [
                                'No se registra información financiera',
                                'Solo especificaciones técnicas'
                            ] 
                        }
                        const attributesBySegment = await axios.get(`${DATAMASTER_ENDPOINT}/attributesBySegment`)
                        const splittedAttBySeg = attributesBySegment.data?.data?.map(attBySeg => ({...attBySeg, attributes: attBySeg.attributes.split(',')}))
                        const filteredAttBySeg = splittedAttBySeg.find(attBySeg => attBySeg.segment === responseVehicleData.SEGMENTO)
                        responseVehicleData.attributesBySegment = filteredAttBySeg.attributes || []
                    } else if (resLineasFinancieras?.length > 0) {
                        const bestFinancingLine = getBestFinancingLine(resLineasFinancieras)
                        const maxAmount = formatNumber.money(parseInt(bestFinancingLine.maximumAmount))
                        const exceedFinanceLimitLegend = getExceedFinanceLimitLegend(bestFinancingLine.exceedFinanceLimit)
                        bestFinancingLineData = {message: [ //arma el objeto con los 2 renglones a mapear
                            `${bestFinancingLine?.bank} - ${bestFinancingLine?.name}`,
                            `Tasa ${bestFinancingLine.tipoTasa} ${bestFinancingLine.tna}% - Monto: ${maxAmount} ${exceedFinanceLimitLegend} - ${bestFinancingLine.monthsTerm} meses`
                        ]}
                    } else {
                        bestFinancingLineData = {message: ['Sin líneas financieras']}
                    }

                }).catch(err => {
                    console.log(err)
                })

                let logo = ''
                if (responseVehicleData?.car_lot_id) {
                    await axios.get(`${FILES_ENDPOINT}/CARDEARLERSHIP_LOGO/${responseVehicleData.car_lot_id}`)
                        .then((r) => {
                            if (r.data?.data?.length) {
                                logo = getThumbnail(r.data.data, true)
                            }
                        })
                }

                const responseData = {
                    vehicle: responseVehicleData,
                    files: responseFilesData,
                    logoCarLot: logo,
                }
                
                dispatch({
                    type: COMPARADOR_LOAD_VEHICLES_SUCCESS,
                    vehicleDetailsData: responseData,
                    index: index,
                    bestFinancingLineData: bestFinancingLineData
                })
            },
            (err) => {
                dispatch({
                    type: COMPARADOR_LOAD_VEHICLES_FAILURE,
                    vehicleDetailsData: { error: err },
                    index: index,
                    bestFinancingLineData: bestFinancingLineData
                })
            }
        )
    }
}

export function reducer(state, action) {
    const { index, vehicleDetailsData, bestFinancingLineData, type } = action
    if (index === undefined) return state
    switch (type) {
        case COMPARADOR_LOAD_VEHICLES_BEGIN: {
            const schema = [...state.schema]
            schema[index].vehicleDetails = {
                isPending: true,
                hasError: null,
                data: null
            }
            schema[index].bestFinancingLine = {loading: true, error: false, data: null}
            
            return {
                ...state,
                schema,
                technicalSpecs: [],
                relevantAttributes: [],
                deleteButtonEnabled: false
            }
        }
        case COMPARADOR_LOAD_VEHICLES_SUCCESS: {
            const schema = [...state.schema]
            schema[index].vehicleDetails = {
                isPending: false,
                hasError: null,
                data: vehicleDetailsData
            }
            schema[index].bestFinancingLine = {loading: false, error: false, data: bestFinancingLineData}

            return {
                ...state,
                schema,
                technicalSpecs: getTechnicalSpecs(schema),
                relevantAttributes: getInitialRelevantAttributes(schema),
                deleteButtonEnabled: true
            }
        }
        case COMPARADOR_LOAD_VEHICLES_FAILURE: {
            const schema = [...state.schema]
            schema[index].vehicleDetails = {
                isPending: false,
                hasError: vehicleDetailsData.error,
                data: null
            }   
            schema[index].bestFinancingLine = {loading: false, error: true, data: bestFinancingLineData}         
            return {
                ...state,
                schema,
                deleteButtonEnabled: true
            }
        }
        default:
            return state
    }
}

